export default {
  REQUIRED: "Поле обов'язкове",
};